// API helper for starting opt-out process
export function startOptOutProcess({
  name,
  email,
  reportToken,
  age,
  knownLocations,
  relatives,
}: {
  name: string;
  email: string;
  reportToken: string;
  age?: number;
  knownLocations?: string[];
  relatives?: string[];
}) {
  return new Promise((resolve, reject) => {
    fetch("/api/startOptOutProcess", {
      method: "POST",
      credentials: "include",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify({
        name,
        email,
        reportToken,
        age,
        knownLocations,
        relatives,
      }),
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          resolve(data.data);
        } else {
          reject(data);
        }
      })
      .catch(error => {
        reject(error);
      });
  });
}
// profileProtectionAPI.ts
// API helper for broker fetch

export function fetchCustomerBrokers() {
  return new Promise((resolve, reject) => {
    fetch("/api/getCustomerBrokers", {
      method: "POST",
      credentials: "include",
      headers: {
        "content-type": "application/json",
      },
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          resolve(data);
        } else {
          reject(data);
        }
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function sendProtectionVerificationCode({ email }: { email: string }) {
  return new Promise((resolve, reject) => {
    fetch("/api/sendProtectionVerificationCode", {
      method: "POST",
      credentials: "include",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify({ email }),
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          resolve(data);
        } else {
          reject(data);
        }
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function verifyProtectionVerificationCode({ code }: { code: string }) {
  return new Promise((resolve, reject) => {
    fetch("/api/verifyProtectionVerificationCode", {
      method: "POST",
      credentials: "include",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify({ code }),
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          resolve(data);
        } else {
          reject(data);
        }
      })
      .catch(error => {
        reject(error);
      });
  });
}
